import CoreCard from './CoreCard';
import {useEffect, useRef, useState} from 'react';
import {easeInOut, motion, useAnimation, useInView, useMotionValue, useMotionValueEvent, useScroll, useTransform} from 'framer-motion';

export default function CoreBlock({ index, data }) {

  const {title, img, subTitle, cards} = data;

  const containerRef = useRef(null);
  const isAutoScrollRef = useRef(false);

  const [isDark, setIsDark] = useState(false);

  const { scrollYProgress } = useScroll({ target: containerRef, offset: ["start start", "end center"] });

  const isInView = useInView(containerRef, { margin: '0px', once: false })

  const imageControl = useAnimation();
  const titleControl = useAnimation();

  useMotionValueEvent(scrollYProgress, 'change' , async (value) => {
    if (isAutoScrollRef.current) return;

    isAutoScrollRef.current = true;

    if (isInView) document.body.style.overflow = "hidden";

    setTimeout(() => setIsDark(true), 500);

    imageControl.start({
      y: 0,
      scale: 1,
      transition: {
        duration: 2,
        ease: 'easeInOut'
      }
    });

    await titleControl.start({
      y: window.innerHeight / 2 - 110,
      transition: {
        duration: 2,
        ease: 'easeInOut'
      }
    });
    
    document.body.style.overflow = "auto";
  });

    useEffect(() => {
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div>
      <div
        data-bg-type={isDark ? 'colorful' : 'white'}
        ref={containerRef}
        className='relative w-full h-[150vh]'
      >
        <div 
          className='absolute top-0 left-0 w-full h-[150vh] z-[1]'
        >
          <div className='sticky top-0 left-0 w-full h-screen'>
            <motion.h2 
              className={`font-bold text-center text-title2 lg:text-display2 whitespace-pre-line ${isDark ? 'text-white' : 'text-black'}`}
              style={{ y: 200 }}
              animate={titleControl}
            >
              {title}
            </motion.h2>
          </div>
        </div>

        <motion.div 
          className='sticky top-0 left-0 w-full h-screen'
          initial={{ scale: 0.6, y: 300 }}
          animate={imageControl}
        >
          {isDark && <div className="absolute inset-0 w-full h-full bg-black opacity-[0.52] z-10"/> }
          <img className="w-full h-full object-left-bottom object-cover" src={`${process.env.REACT_APP_STATIC_URL}/images/Core/Section${index + 1}_Background.jpg`} alt={title}/>
          
        </motion.div>
      </div>

      <div
        data-bg-type='white'
        className='wrapper mt-[120px] lg:mt-[320px]'
      >
        <div className='text-center font-bold text-title3 lg:text-display2 text-label-500'>
          {subTitle}
        </div>
        <div className='flex flex-col gap-y-[72px] lg:gap-y-[200px] mt-[60px] lg:mt-[160px]'>
          {
            cards.map((item, idx) => <CoreCard key={idx} block={index} index={idx} data={item}/>)
          }
        </div>
      </div>
    </div>
  )
}